export enum SalesOrderStatusEnum {
  NOT_INVOICED = 'NOT_INVOICED',
  SENT_TO_ERP = 'SENT_TO_ERP',
  INVOICED = 'INVOICED',
  PAID = 'PAID',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED'
}
